import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import colors from 'vuetify/es5/util/colors'

/**
 * Predefined colours are found here: https://vuetifyjs.com/en/style/colors
 */

Vue.use(Vuetify, {
    iconfont: 'md',
    theme: {
        alternateCard: "#e0e0e0",
        primary: colors.blue.darken2, // this is used for more than just buttons (eg highlighting of input elements) - be careful when changing
        success: colors.green.lighten2,
        error: colors.red.lighten2,
        warning: colors.orange.lighten2,
        info: colors.blue, // this is used for more than just buttons - be careful when changing
        accent: colors.blue.lighten2,
        navigation: colors.lightBlue.lighten2
    }
});

Vue.use(require('vue-moment'));